import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { coreDataSecurityAccessAuditByIdReducers, coreDataSecurityAccessAuditByIdWatchers } from './_id';
import { coreDataSecurityAccessAuditExportReducers, coreDataSecurityAccessAuditExportWatchers } from './export';

export const coreDataSecurityAccessAuditReducers = combineReducers({
	byId: coreDataSecurityAccessAuditByIdReducers,
	export: coreDataSecurityAccessAuditExportReducers
});

export const coreDataSecurityAccessAuditWatchers = combineAllWatchers([
	coreDataSecurityAccessAuditByIdWatchers,
	coreDataSecurityAccessAuditExportWatchers
]);
